import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export enum InputType {
  button = 'button',
  color = 'color',
  date = 'date',
  datetimelocal = 'datetime-local',
  email = 'email',
  month = 'month',
  number = 'number',
  password = 'password',
  search = 'search',
  tel = 'tel',
  text = 'text',
  time = 'time',
  url = 'url',
  week = 'week',
}

export interface IDynamicTypeMixin {
  type: InputType | undefined;
}
export type DynamicTypeCtor = Constructor<IDynamicTypeMixin>;

export function mixinDynamicType<T extends Constructor<{}>>(base: T): DynamicTypeCtor & T {
  class DynamicTypeMixin extends base implements IDynamicTypeMixin {
    @DynamicProperty() type: InputType | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicTypeMixin;
}
